<template>
  <div class="login-container">
    <h2>Login to Book an Appointment</h2>

    <form @submit.prevent="login">
      <label>Email:</label>
      <input v-model="email" type="email" placeholder="Enter your email" required />

      <label>Password:</label>
      <input v-model="password" type="password" placeholder="Enter your password" required />

      <button type="submit">Login</button>
    </form>

    <p>Don't have an account? <span @click="toggleSignup">Sign Up</span></p>

    <button class="google-btn" @click="loginWithGoogle">
      <img src="../assets/google-icon.png" alt="Google Logo" /> Sign in with Google
    </button>

    <div v-if="showSignup">
      <h2>Sign Up</h2>
      <form @submit.prevent="signup">
        <label>Email:</label>
        <input v-model="email" type="email" placeholder="Enter your email" required />

        <label>Password:</label>
        <input v-model="password" type="password" placeholder="Create a password" required />

        <button type="submit">Create Account</button>
      </form>
    </div>
  </div>
</template>

<script>

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup,onAuthStateChanged ,signInWithEmailAndPassword,createUserWithEmailAndPassword} from "firebase/auth";
import { getAnalytics,logEvent } from "firebase/analytics";

export default {
  data() {
    return {
      email: "",
      password: "",
      showSignup: false,
      firebaseConfig: {
        apiKey: process.env.VUE_APP_API_KEY,
        authDomain: process.env.VUE_APP_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_DATABASE_URL,
        projectId: process.env.VUE_APP_PROJECT_ID,
        storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_APP_ID,
        measurementId: process.env.VUE_APP_MEASUREMENT_ID,
      },
    };
  },
  async mounted() {
    const app = initializeApp(this.firebaseConfig);
    const auth = getAuth();
    const analytics = getAnalytics(app);
    logEvent(analytics, "page_view_bigben", { page_title: "first page",debug_mode: true  })
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("🚀 ~ file: LoginBooking.vue ~ line 47 ~ onAuthStateChanged ~ user", user)
        this.$router.push("/booking");
      }
    });
  },
  methods: {
    async login() {
      const auth = getAuth();
  const provider = new GoogleAuthProvider();
  provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password);
        alert("✅ Logged in successfully!");
        this.$router.push("/booking");
      } catch (error) {
        console.error("❌ Login Error:", error);
        alert("❌ " + error.message);
      }
    },
    async signup() {
      const auth = getAuth();
  const provider = new GoogleAuthProvider();
  provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
      try {
        await createUserWithEmailAndPassword(auth, this.email, this.password);
        alert("✅ Account created successfully! Please log in.");
        this.showSignup = false;
      } catch (error) {
        console.error("❌ Signup Error:", error);
        alert("❌ " + error.message);
      }
    },
    async loginWithGoogle() {
      try {
        const auth = getAuth();
        const provider = new GoogleAuthProvider();
        // provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
        await signInWithPopup(auth, provider) .then(async (result) => {
          const user = result.user;
          console.log("✅ Google Login Success:", user);
          console.log("✅ Google Login Success:", result.user);
          
          alert(`✅ Logged in as ${result.user.displayName}`);
          this.$router.push("/booking");
        })
    .catch((error) => {
      console.error("Error signing in with Google:", error);
    });
        
      } catch (error) {
        console.error("❌ Google Sign-In Failed:", error);
        alert("❌ Google Sign-In Failed: " + error.message);
      }
    },
    toggleSignup() {
      this.showSignup = !this.showSignup;
    }
  }
};
</script>

<style scoped>
.login-container {
  text-align: center;
  max-width: 400px;
  margin: auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
input, button {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
}
button {
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
.google-btn {
  background-color: white;
  color: black;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}
.google-btn img {
  width: 20px;
  margin-right: 10px;
}
p span {
  color: #007bff;
  cursor: pointer;
}
p span:hover {
  text-decoration: underline;
}
</style>
